var React = require('react');

function Apis (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000, 2.000000)"},[React.createElement("g",{"transform":"translate(24.500000, 9.500000) rotate(-45.000000) translate(-24.500000, -9.500000) translate(18.000000, 3.000000)","key":0},[React.createElement("polyline",{"points":"2 0 13 0 13 11","key":0}),React.createElement("path",{"d":"M13,0 L0,13","key":1})]),React.createElement("g",{"transform":"translate(9.500000, 18.500000) rotate(-45.000000) translate(-9.500000, -18.500000) translate(3.000000, 12.000000)","key":1},[React.createElement("polyline",{"points":"11 13 0 13 0 2","key":0}),React.createElement("path",{"d":"M0,13 L13,0","key":1})])]));
}

Apis.defaultProps = {"fill":"none","stroke":"currentColor","strokeWidth":"3","viewBox":"0 0 34 32"};

module.exports = Apis;

Apis.default = Apis;
